<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells position="between">
        <app-cells :indent="false">
          <app-button @click.native="onCheckDevice" size="small" theme="warn" ref="check" :disabled="!!device">
            Check device
          </app-button>
          <app-button @click.native="onStartScanner" size="small" theme="info" ref="start" :disabled="!!!device">
            {{ is_new_session === 'Yes' ? 'Start scan' : 'Continue scanning' }}
          </app-button>
          <app-button @click.native="onEnrollmentSave" size="small" ref="save" :disabled="!enrollment_data.fingers">
            Save
          </app-button>
        </app-cells>
        <app-cells :indent="false">
          <app-button @click.native="onVerifyInit" size="small" theme="warn" ref="verify_start">Verify</app-button>
          <app-button @click.native="onFingersDelete" size="small" theme="error" ref="delete">Delete</app-button>
        </app-cells>
      </app-cells>
      <img
        v-if="scaner_checked"
        :src="`data:image/png;base64,${image_live}`"
        alt=""
        width="600"
        height="600"
        style="border: 1px solid #ddd9d9;"
      />
      <p>{{ info_message }}</p>
      <p>{{ info_c_message }}</p>
      <app-cells v-if="is_scanning">
        <img
          v-if="l_slap"
          :src="`data:image/${l_slap}`"
          alt=""
          width="400"
          height="375"
          :style="{border: `1px solid ${is_l_slap ? '#77b017' : '#f36161'}`}"
        />
        <img
          v-if="c_slap"
          :src="`data:image/${c_slap}`"
          alt=""
          width="400"
          height="375"
          :style="{border: `1px solid ${is_c_slap ? '#77b017' : '#f36161'}`}"
        />
        <img
          v-if="r_slap"
          :src="`data:image/${r_slap}`"
          alt=""
          width="400"
          height="375"
          :style="{border: `1px solid ${is_r_slap ? '#77b017' : '#f36161'}`}"
        />
      </app-cells>
      <app-cells>
        <app-form-group v-for="item in fingers" :key="item.id" :label="item.finger.name">
          <div class="finger" :style="{border: `1px solid ${item.fingerprint.image ? '#77b017' : '#f36161'}`}">
            <img
              v-if="item.fingerprint.image"
              :src="`data:image/png;base64,${item.fingerprint.image}`"
              alt=""
              width="100"
              height="130"
            />
          </div>
        </app-form-group>
      </app-cells>
    </template>
    <modal
      name="verify"
      :width="540"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('verify')" class="popup__close" type="button"></button>
        <div class="popup__title">Verify</div>
        <app-cells>
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
        </app-cells>
        <div class="popup__body">
          <form style="text-align: center">
            <img v-if="is_img_show" :src="`http://localhost:5678/img/PreviewStreaming.bmp?dummy=${Math.random()}&shandle=${device_handle}&id=0`" alt="">
            <app-cells v-if="info_message">
              <p>{{ info_message }}</p>
            </app-cells>
            <app-cells position="center">
              <app-button @click.native="onVerifyStart" theme="info" ref="verify">Verify</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getNewFingerprintCanvasInfo,
  getNewFingerprintCheckDevice,
  postNewFingerprintLRT,
  postNewFingerprintEnrollmentData,
  getFingerprintInitDevice,
  getFingerprintStartCapturing,
  getFingerprintScannerStatus,
  getFingerprintSetParameters,
  getFingerprintTemplateData,
  postEmployeesFingerprintsVerify,
  getEmployeesFingerprintsList,
  deleteNewFingerprintEnrollmentData,
} from '@/http'

export default {
  name: 'EmployeeBiometry',
  props: {
    employee: Object
  },
  data() {
    return {
      is_loaded: false,
      scaner_checked: false,
      device: '',
      is_new_session: 'Yes',
      image_live: 'R0lGODlhAQABAIAAAP7//wAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==',
      info_message: '',
      info_c_message: '',
      enrollment_data: {},
      interval: null,
      l_slap: null,
      c_slap: null,
      r_slap: null,
      is_l_slap: false,
      is_c_slap: false,
      is_r_slap: false,
      is_scanning: false,
      device_handle: null,
      is_img_show: false,
      fingers: [],
    }
  },
  created() {
    this.fetchItems()
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    }
  },
  methods: {
    onFingersDelete() {
      this.$refs.delete.preload = true
      deleteNewFingerprintEnrollmentData({ status: 'employee', board_id: this.$route.params.id })
        .finally(() => { this.$refs.delete.preload = false })
        .then(() => {
          this.fetchItems()
          this.$notify({
            type: 'success',
            title: 'Fingerprints removed successfully',
          })
        })
    },
    fetchItems() {
      getEmployeesFingerprintsList(this.$route.params.id)
        .then(res => {
          this.fingers = res.data
          this.is_loaded = true
        })
    },
    setVerifyParameters() {
      getFingerprintSetParameters(Math.random(), this.device_handle, 2002)
        .then(() => {
          getFingerprintTemplateData(Math.random(), this.device_handle)
            .then(res => {
              if (res.data.retValue !== '0') {
                this.$notify({
                  type: 'error',
                  title: res.data.retString,
                })
                this.info_message = 'Scan error'
              } else {
                postEmployeesFingerprintsVerify({
                  template: res.data.templateBase64,
                  status: 'employee',
                  board_id: this.$route.params.id
                })
                  .finally(() => { this.$modal.hide('verify') })
                  .then(res => {
                    this.$notify({
                      type: 'success',
                      title: res.data.detail,
                    })
                  })
                  .catch(error => {
                    this.$notify({
                      type: 'error',
                      title: error.response.data.detail
                    })
                  })
              }
            })
        })
    },
    getVerifyStatus() {
      getFingerprintScannerStatus(Math.random(), this.device_handle)
        .then(res => {
          if (res.data.IsCapturing === 'false') {
            this.setVerifyParameters()
          } else {
            setTimeout(this.getVerifyStatus, 200)
          }
        })
    },
    onVerifyStart() {
      this.$refs.verify.preload = true
      getFingerprintStartCapturing(Math.random(), this.device_handle)
        .then(() => {
          this.getVerifyStatus()
          this.is_img_show = true
        })
    },
    onVerifyInit() {
      if (!this.device_handle) {
        this.$refs.verify_start.preload = true
        getFingerprintInitDevice(Math.random())
          .finally(() => { this.$refs.verify_start.preload = false })
          .then(res => {
            if (res.data.retValue !== '0') {
              this.$notify({
                type: 'error',
                title: res.data.retString,
              })
            } else {
              this.$notify({
                type: 'success',
                title: `Scanner ${res.data.ScannerInfos[0].ScannerName} found. You can keep working`,
              })
              this.device_handle = res.data.ScannerInfos[0].DeviceHandle
              this.$modal.show('verify')
            }
          })
          .catch(() => {
            this.$notify({
              type: 'error',
              title: 'Something went wrong on initDevice',
            })
          })
      } else {
        this.$modal.show('verify')
      }
    },
    onEnrollmentSave() {
      this.$refs.save.preload = true
      this.enrollment_data.person = {
        first_name: this.employee.first_name,
        last_name: this.employee.last_name,
        board_id: this.employee.id,
        status: 'employee'
      }
      postNewFingerprintEnrollmentData(this.enrollment_data)
        .finally(() => {
          this.$refs.save.preload = false
        })
        .then(() => {
          this.fetchItems()
          this.is_scanning = false
          this.$notify({
            type: 'success',
            title: 'Data saved'
          })
        })
        .catch(error => {
          this.$notify({
            type: 'error',
            title: error.response.data.detail
          })
        })
    },
    getCanvasInfo() {
      getNewFingerprintCanvasInfo()
        .then(res => {
          if (res.data.imgData !== '') {
            this.image_live = res.data.imgData
            this.info_message = res.data.msg
            this.info_c_message = res.data.cmsg
          } else {
            this.info_message = ''
            this.info_c_message = ''
            this.image_live = 'R0lGODlhAQABAIAAAP7//wAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=='
          }
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Suprema service is not running'
          })
        })
    },
    livePreview() {
      this.interval = setInterval(this.getCanvasInfo, 30)
    },
    onStartScanner(captureType = 'LRT') {
      this.livePreview()
      this.$refs.start.preload = true

      postNewFingerprintLRT({
        captureMode: 'PLAIN',
        captureType: 'LRT',
        missingFingers: '',
        imageFormat: 'JPEG',
        isoFMRFormat: 'FMR2005',
        isoFIRFormat: 'FIR2005',
        isNewSession: this.is_new_session
      })
        .finally(() => {
          this.$refs.start.preload = false
        })
        .then(res => {
          clearInterval(this.interval)
          this.is_scanning = true
          this.enrollment_data = res.data
          this.is_new_session = res.data.isNewSession
          if (res.data.slaps.length) {
            if (res.data.slaps[0]) {
              this.l_slap = `data:image/${res.data.slaps[0].imgType.toLowerCase()};base64,${res.data.slaps[0].imgData}`
              this.is_l_slap = true
            } else {
              this.l_slap = 'data:image/png;base64,R0lGODlhAQABAIAAAP7//wAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=='
              this.is_l_slap = false
            }
            if (res.data.slaps[1]) {
              this.c_slap = `data:image/${res.data.slaps[1].imgType.toLowerCase()};base64,${res.data.slaps[1].imgData}`
              this.is_c_slap = true
            } else {
              this.c_slap = 'data:image/png;base64,R0lGODlhAQABAIAAAP7//wAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=='
              this.is_c_slap = false
            }
            if (res.data.slaps[2]) {
              this.r_slap = `data:image/${res.data.slaps[2].imgType.toLowerCase()};base64,${res.data.slaps[2].imgData}`
              this.is_r_slap = true
            } else {
              this.r_slap = 'data:image/png;base64,R0lGODlhAQABAIAAAP7//wAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=='
              this.is_r_slap = false
            }
          } else {
            this.l_slap = 'data:image/png;base64,R0lGODlhAQABAIAAAP7//wAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=='
            this.is_l_slap = false
            this.c_slap = 'data:image/png;base64,R0lGODlhAQABAIAAAP7//wAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=='
            this.is_c_slap = false
            this.r_slap = 'data:image/png;base64,R0lGODlhAQABAIAAAP7//wAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=='
            this.is_r_slap = false
          }
          if (res.data.isNewSession === 'No') {
            this.$notify({
              type: 'info',
              title: res.data.errMsg
            })
          } else {
            this.$notify({
              type: 'success',
              title: 'Scan was successful'
            })
          }
        })
    },
    onCheckDevice() {
      this.$refs.check.preload = true
      getNewFingerprintCheckDevice()
        .finally(() => {
          this.$refs.check.preload = false
        })
        .then(res => {
          if (res.data.isConnected) {
            this.scaner_checked = true
            this.device = res.data.model
            this.$notify({
              type: 'success',
              title: `Scanner ${res.data.model} is connected..!`
            })
          } else {
            this.$notify({
              type: 'info',
              title: 'Scanner is not connected..!'
            })
          }
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Suprema service is not running'
          })
        })
    }
  }
}
</script>
<style lang="sass" scoped>
.finger
  width: 100px
  height: 130px
  line-height: 0
  text-align: center

  img
    height: 100%
</style>